'use strict'

import $ from 'jquery';
import Highcharts from 'highcharts/highstock';
import { lib } from '../../common/Library';
import { chartLib } from '../../common/ChartLibrary';

/**
 * 個別銘柄 - 年間1株配当推移
 *
 * @param {string} divId 表示div id
 */
const ZaimuDps = function(divId) {
    try {
        let jsonEnv = []; // 環境用JSON

        // S3からグラフJSONを取得
        $.ajax({
            url: $('#dpsJsonUrl').val(),
            dataType: 'jsonp',
            jsonpCallback: 'z_dps' + $('#stockCd').val(),
            async: false
        })
        .done(function (json) {
            // グラフデータの編集
            editGraphData(json, jsonEnv);
            // グラフの生成
            createGraph(divId, json, jsonEnv);
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.log('status:' + textStatus);
            console.log('response:' + jqXHR.responseText);
        });
    } catch (e) {
        console.log(e);
    }

    /**
     * グラフデータを編集
     *
     * @param {object} json データJSON
     * @param {object} jsonEnv 環境JSON
     */
    function editGraphData(json, jsonEnv) {
        let dataCnt = 0;
        let kessanNum = 5; // 表示期数
        let sliceNum = kessanNum;

        // X軸のcategoriesに表示する項目をjsonから取得
        jsonEnv['categories'] = [];
        jsonEnv['xAxis'] = [];
        if (json[0] !== null) {
            //予想データがある場合、kessanNumをカウントアップ
            if (json[0].data.slice(-1)[0][0].indexOf('予') !== -1) {
                sliceNum = kessanNum + 1;
            }

            // 5期に削る
            json[0].data = json[0].data.slice(-sliceNum);

            let dataCntKey = Object.keys(json[0].data).length - 1; // 配列のdata最大件数 - 1 が添え字の最大値

            for (dataCnt = 0; dataCnt <= dataCntKey; dataCnt++) {
                // categories
                jsonEnv['categories'].push(json[0].data[dataCnt][0]);
            }

            // プロパティが残っているとエラーになるので削除
            delete json[0].xAxis;
        }

        // グラフの色設定　一番右のみ赤色にする
        jsonEnv['colors'] = [];
        for (let colorCnt = 0; colorCnt < dataCnt; colorCnt++) {
            if (colorCnt === dataCnt - 1) {
                //一番右のグラフ色
                jsonEnv['colors'].push('#c00000');
            } else {
                jsonEnv['colors'].push('#4f81bd');
            }
        }
    }

    /**
     * グラフを生成
     *
     * @param {string} divId グラフ出力先の<div>タグのID
     * @param {object} json jsonデータ
     * @param {object} jsonEnv 環境JSON
     */
    function createGraph(divId, json, jsonEnv) {
        Highcharts.setOptions({
            // 縦軸の数値にカンマ表示
            lang: {
                thousandsSep: ','
            },
            // 表示をUTCからローカルタイムにする
            global: {
                useUTC: false
            }
        });

        $(divId).highcharts({
            chart: {
                style: {
                    fontFamily: $('#fontFamily').val()
                }
            },
            title: {
                text: '年間1株配当推移',
                margin: 0,
                style: {
                    fontSize: 15,
                    fontWeight: 'bold'
                }
            },
            // 横軸
            xAxis: {
                title: {
                    text: null
                },
                categories: jsonEnv.categories,
                tickmarkPlacement: 'between', // 目盛線の位置 between,on
                tickPosition: 'inside', // 目盛線の表示場所 inside:内側 outside:外側
                labels: {
                    style: {
                        color: '#000'
                    }
                },
                // ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                // 補助線の設定
                tickLength: 7,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                crosshair: true // マウスホバーした時の縦線表示設定
            },
            // 縦軸
            yAxis: { // 左側 0
                title: {
                    text: null
                },
                labels: {
                    format: '{value:.,0f} 円', // ラベルのフォーマット設定
                    style: {
                        color: '#000'
                    }
                },
                // 縦軸補助線の設定
                gridLineColor: '#c3c3c3',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid', // 縦軸線スタイル dash:点線 solid:線
                // 縦軸ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                // 縦軸補助線の設定
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                tickAmount: 6
            },
            // マウスホバー時の設定
            tooltip: {
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:.2f} 円</b><br/>',
                style: {
                    fontSize: '11px'
                },
                hideDelay: 100, // マウスを外してからtooltipが消えるまでの時間
                shared: true, // 縦列グループ化
                positioner: function(boxWidth, boxHeight, point) {
                    return chartLib.tooltipPositioner(this, boxWidth, boxHeight, point);
                }
            },
            legend: false, // 凡例
            exporting: false,
            credits: false, // 右下公式クレジット表示設定
            plotOptions: {
                column: {
                    yAxis: 0,
                    borderWidth: 0,
                    animation: false,
                    // 折れ線グラフ点表示設定
                    marker: {
                        enabled: true,
                        radius: 1 // プロットの大きさ
                    }
                },
                series: {
                    colors: jsonEnv.colors, // 予想のみ赤色
                    colorByPoint: true
                }
            },
            //データ
            series: json
        });
    }
};

export { ZaimuDps };
